function addDays(wdays) {
  const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  
  const date = new Date();
  const today = date.getDay();
                          
  var count = 0;
  var extra_days = 0;
  var total_days = 0;
  var end_day = 0;
  
  var ij = 1; 
  while (count != wdays || (end_day == 6 || end_day == 0)) {
    var add_day = today + ij;
    
    // check days in mod 7 system
    if (add_day < 7) {
      var new_day = add_day;
    }
    
    else {
      var new_day = add_day % 7;
    }
    
    // add working days, add more days for weekends
    if (new_day == 0 || new_day == 6) {extra_days++;} else {count++;}
    
    total_days = wdays + extra_days;
    
    end_day = (today + total_days) % 7;
      
    ij++;
  }
    
  // eta before cut-off time
  date.setDate(date.getDate() + total_days);
    
  const eta_day = weekday[date.getDay()];
  const eta_month = month[date.getMonth()];
  const eta_date = date.getDate();
    
  const eta = eta_day + ', ' + eta_month + ' ' + eta_date;
    
  return eta;
}


  